export const inputStyles = {
    components: {

        // Styling the <Input> Element
        Input: {
            baseStyle: {
                field: {
                    fontWeight: 400,
                    borderRadius: "8px",
                },
            },

            variants: {
                default: (props) => ({
                    field: {
                        border: "1px solid",
                        borderColor: 'grey.600',
                        fontSize: '1.6rem',
                        color: "text.900",
                        borderRadius: "1rem",
                        p: "2rem",
                        _placeholder: { color: "grey.500" },
                    },
                }),
            },
        },

        //Styling the <textarea> element
        Textarea: {
            baseStyle: {
                field: {
                    fontWeight: 400,
                    borderRadius: "8px",
                },
            },

            variants: {
                default: (props) => ({

                    border: "1px solid",
                    borderColor: 'grey.600',
                    fontSize: '1.6rem',
                    color: "text.900",
                    borderRadius: "1rem",
                    p: "1rem",
                    _placeholder: { color: "grey.500" },
                    h: 'auto',

                }),
            },
        },

        NumberInput: {
            baseStyle: {
                field: {
                    fontWeight: 400,
                },
            },

            variants: {
                default: (props) => ({
                    field: {
                        border: "1px solid",
                        borderColor: 'grey.600',
                        fontSize: '1.6rem',
                        color: "text.900",
                        borderRadius: "1rem",
                        p: "1rem",
                        textAlign: 'center',
                        _placeholder: { color: "grey.500" },
                        h: 'auto',

                    }

                }),
            },
        },
        Select: {
            baseStyle: {
                field: {
                    fontWeight: 400,
                },
            },

            variants: {
                default: (props) => ({
                    field: {
                        border: "1px solid",
                        h: 'auto',
                        borderColor: 'grey.600',
                        fontSize: '1.6rem',
                        color: "text.900",
                        borderRadius: "1rem",
                        p: '1rem',
                        _placeholder: { color: "grey.500" },
                        display: 'flex',
                        alignItems: 'center'

                    },
                    icon: {
                        color: "secondaryGray.600",
                        textAlign: 'center'
                    },
                }),


            },
        },
        FormLabel: {
            baseStyle: {
                fontSize: '1.6rem'
            }
        }

    },
};
